import { UserModel } from './user.model';
import { TipoVehiculoModel } from './tipo-vehiculo.model';
import { TipoCombustibleModel } from './tipo-combustible.model';
import { UsoVehiculoModel } from './uso-vehiculo.model';
import { EstadoSolicitudModel } from './estado-solicitud.model';
import { DistintoAmbientalModel } from './distintivo-ambiental.model';
import { SectorModel } from './sector.model';
import { TipoPlazaModel } from './tipo-plaza.model';

export class VehiculoModel {

  id: number;
  propietario: UserModel;
  tipoVehiculo: TipoVehiculoModel;
  tipoCombustible: TipoCombustibleModel;
  usoVehiculo: UsoVehiculoModel;
  estadoSolicitud: EstadoSolicitudModel;
  distintivoAmbiental: DistintoAmbientalModel;
  sector: SectorModel;
  clasificacionVehiculo: TipoPlazaModel;
  matricula: string;
  peso: number;
  cambios: string[];
  nDisco: number;

  constructor() {
    this.tipoVehiculo = new TipoVehiculoModel();
    this.tipoCombustible = new TipoCombustibleModel();
    this.usoVehiculo = new UsoVehiculoModel();
    this.distintivoAmbiental = new DistintoAmbientalModel();
    this.sector = new SectorModel();
    this.clasificacionVehiculo = new TipoPlazaModel();
    this.matricula = '';
    this.peso = null;
    this.cambios = [];
    this.nDisco = null;
  }
}
